import styled from '@emotion/styled'
import themeVars from 'ui_theme/site/globals/site.variables'
import { Header as UIHeader } from 'shared/ui'

export const Container = styled('div')`
  padding: ${props => props.theme.spacing['10']}
    ${props => props.theme.spacing['12']};
`

export const Header = styled(({ children, ...props }) => (
  <UIHeader as="h3" className="grui my-10" truncate {...props}>
    {children}
  </UIHeader>
))`
  &&& {
    font-size: 16px !important;
    font-weight: ${themeVars.pageFontWeightSemiBold} !important;
  }
`
